import http from "./http";
import { clearActiveGroup } from "@/utils/activeGroup";

export function setSession(token, user) {
  localStorage.setItem("token", token);
  localStorage.setItem(
    "user",
    JSON.stringify(user)
  );
}

export function getUser() {
  try {
    return JSON.parse(
      localStorage.getItem("user") || "null"
    );
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  clearActiveGroup();
}

export async function me() {
  const response = await http.get("/auth/me");

  return response.data.user;
}

export function isAuthed() {
  return Boolean(
    localStorage.getItem("token")
  );
}

export function logout() {
  clearSession();
}